import { ButtonGroup } from 'react-bootstrap';
import styled from 'styled-components';

export const ModeSwitcherButtonsContainer = styled(ButtonGroup)`
  margin-right: 15px;
`;
